import { connect } from "react-redux";
import "./styles.css";

const NotificationBadgeCount = (props) => {
  const count = props.unreadCount || props.count || 0;
  if (!count || count === 0) return <></>;
  return (
    <div
      className={`notification-counter ${props.borderClassName || ""}`}
      style={props.styles}
    >
      <span>{count > 99 ? "99+" : count}</span>
    </div>
  );
};

const mapStateToProps = (state) => ({
  unreadCount: state.InAppNotification?.unreadCount || 0,
});

export default connect(mapStateToProps)(NotificationBadgeCount);
